import React from 'react';
import PropTypes from 'prop-types';

function IconPlay({ className }) {
  return (
    <svg width="32" height="20" viewBox="0 0 32 20" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="20" rx="2" fill="#383838"/>
      <path d="M19.9211 9.59147C20.2034 9.79067 20.2034 10.2093 19.9211 10.4085L14.5383 14.2069C14.2071 14.4406 13.75 14.2037 13.75 13.7984L13.75 6.20164C13.75 5.79626 14.2071 5.55939 14.5383 5.79311L19.9211 9.59147Z" fill="#8F8F8F"/>
    </svg>
  )
}

IconPlay.propTypes = {
  className: PropTypes.string
}

export default IconPlay;
